module.exports = __webpack_public_path__ + "static/pricing-freelance-projects-og-image-80221891cb7e79daa4663ca7f0618a0b.png";